/**
 * LEGACY. No usar en código nuevo: usa features/rangos/api/rangos.api.js.
 *
 * Este servicio sobrevive a la migración del feature "rangos" (ago 2026) por un
 * único consumidor: src/views/Stickers.js, que lo importa y llama a getRangos()
 * en las líneas 102 y 120. La vista y el modal legacy de rangos ya se retiraron,
 * y createRango/updateRango/deleteRango quedan aquí sin ningún consumidor.
 *
 * Condición para retirarlo por completo: migrar views/Stickers.js a
 * RangosService de features/rangos. Verificado (sep 2026) que el cambio SÍ es
 * transparente: Stickers solo lee item.rango, item.precio e item.palet, y esos
 * tres campos conservan el mismo nombre al normalizar; normalizeRango únicamente
 * renombra id_rango e id_agencia, que Stickers no usa. Serían dos líneas: el
 * import y getRangos() -> list(). De hecho mejoraría el aviso de error, porque
 * list() lanza un Error con mensaje legible y este servicio propaga el de axios
 * en crudo, que es lo que Stickers pinta en el toast.
 */
import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";

class RangosService {

    /**
     * Crear rango
     * @param rango
     * @returns {Promise<AxiosResponse<any>>}
     */
    static createRango(item) {
        return axios.post(HostService.getHost() + 'rutas/rangos/crear/',
            {
                id_agencia: item.id_agencia, 
                rango: item.rango, 
                precio: item.precio,  
                palet: item.palet, 
                isla: item.isla, 
            }, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Obtener rangos
     * @returns {Promise<AxiosResponse<any>>}
     */
    static getRangos() {
        return axios.get(HostService.getHost() + 'rutas/rangos/', AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Borrar incidencia
     * @param id_order
     * @returns {Promise<AxiosResponse<any>>}
     */
    static deleteRango(id) {
        return axios.delete(HostService.getHost() + 'rutas/rangos/eliminar?id='+id, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Modificar incidencia
     * @returns {Promise<AxiosResponse<any>>}
     */
     static updateRango(item) {
        return axios.put(HostService.getHost() + 'rutas/rangos/modificar/'+item.id_rango, { 
            id_agencia: item.id_agencia, 
            rango: item.rango, 
            precio: item.precio,  
            palet: item.palet,
            isla: item.isla,   
        }, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

}

export default RangosService;